var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input, ViewChild, NgZone, HostListener, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AbstractComponent, ExternalResourceService, ConfigService } from 'gp-admin-abstract';
var YandexMapComponent = /** @class */ (function (_super) {
    __extends(YandexMapComponent, _super);
    function YandexMapComponent(el, domSanitizer, zone, externalResourceService, config) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.domSanitizer = domSanitizer;
        _this.zone = zone;
        _this.externalResourceService = externalResourceService;
        _this.config = config;
        _this.center = [];
        _this.zoom = 10;
        _this.disabled = false;
        _this.isScrolled = false;
        _this.allowChoosePoint = true;
        _this.onLoad = new EventEmitter();
        _this.onInit = new EventEmitter();
        _this.onChangeBounds = new EventEmitter();
        _this.onViewCheck = new EventEmitter();
        _this.onRemoveAll = new EventEmitter();
        _this.onPanToDone = new EventEmitter();
        _this.isInitialized = false;
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    YandexMapComponent.prototype.ngOnInit = function () {
        this.widthSafeStyle = this.domSanitizer.bypassSecurityTrustStyle(this.width ? this.width : '100%');
        this.heightSafeStyle = this.domSanitizer.bypassSecurityTrustStyle(this.height ? this.height + 'px' : 'calc(100vh)');
        this.initYmaps();
    };
    YandexMapComponent.prototype.ngOnDestroy = function () {
        if (this.map) {
            this.map.destroy();
        }
    };
    YandexMapComponent.prototype.ngAfterViewChecked = function () {
        this.onViewCheck.emit();
    };
    YandexMapComponent.prototype.writeValue = function (obj) {
        this.value = obj;
        if (obj && obj.length === 2 && this.map) {
            this.setCoordinate(obj);
        }
    };
    YandexMapComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    YandexMapComponent.prototype.registerOnTouched = function (fn) {
    };
    YandexMapComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * Инициализация карт Yandex
     */
    YandexMapComponent.prototype.initYmaps = function () {
        var _this = this;
        this.externalResourceService.loadScript(this.config.getConfig().externalServices.ymaps).then(function () {
            _this.zone.runOutsideAngular(function () {
                ymaps.ready().then(function () {
                    _this.onLoad.emit(ymaps);
                    _this.map = new ymaps.Map(_this.container.nativeElement, {
                        center: _this.value ? _this.value : _this.center,
                        zoom: _this.zoom,
                        controls: ['zoomControl']
                    }, {
                        suppressMapOpenBlock: true
                    });
                    _this.isInitialized = true;
                    _this.onInit.emit(_this.map);
                    if (_this.allowChoosePoint) {
                        _this.map.events.add('click', function (e) {
                            _this.setPoint(e.get('coords'));
                        });
                    }
                    _this.map.events.add('boundschange', function (e) {
                        var fields = [
                            'oldCenter', 'newCenter', 'oldZoom', 'newZoom', 'oldGlobalPixelCenter', 'newGlobalPixelCenter',
                            'oldBounds', 'newBounds'
                        ], bounds = {};
                        if (e) {
                            for (var i = 0; i < fields.length; i++) {
                                bounds[fields[i]] = e.get(fields[i]);
                            }
                            _this.onChangeBounds.emit(bounds);
                        }
                    });
                    if (!_this.isScrolled) {
                        _this.disableScrollZoom();
                    }
                    if (_this.value) {
                        _this.setPoint(_this.value);
                    }
                });
            });
        });
    };
    YandexMapComponent.prototype.disableScrollZoom = function () {
        if (this.isInitialized) {
            this.map.behaviors.disable('scrollZoom');
        }
    };
    YandexMapComponent.prototype.enableScrollZoom = function () {
        if (this.isInitialized) {
            this.map.behaviors.enable('scrollZoom');
        }
    };
    YandexMapComponent.prototype.removeAllObjects = function () {
        var _this = this;
        if (this.isInitialized) {
            this.zone.runOutsideAngular(function () {
                _this.map.geoObjects.removeAll();
                _this.onRemoveAll.emit();
            });
        }
    };
    YandexMapComponent.prototype.addPlacemark = function (placemark) {
        var _this = this;
        if (this.isInitialized) {
            this.zone.runOutsideAngular(function () {
                _this.map.geoObjects.add(placemark);
            });
        }
    };
    YandexMapComponent.prototype.reDraw = function () {
        var _this = this;
        if (this.map) {
            this.zone.runOutsideAngular(function () {
                _this.map.container.fitToViewport();
            });
        }
    };
    /**
     * Метод установки точки на карте
     *
     * @param point
     */
    YandexMapComponent.prototype.setPoint = function (point) {
        var _this = this;
        if (this.isInitialized) {
            this.zone.runOutsideAngular(function () {
                var placemark = new ymaps.Placemark(point, _this.placemarkOptions);
                _this.removeAllObjects();
                _this.addPlacemark(placemark);
                _this.propagateChange(point);
            });
        }
    };
    /**
     * Метод установки нового центра карты
     *
     * @param {number[]} coordinate
     */
    YandexMapComponent.prototype.setCoordinate = function (coordinate) {
        var _this = this;
        if (this.map) {
            ymaps.ready().then(function () {
                _this.map.panTo(coordinate, { checkZoomRange: true })
                    .then(function () {
                    _this.onPanToDone.emit();
                });
            });
        }
    };
    YandexMapComponent.prototype.onWindowResize = function () {
        this.reDraw();
    };
    YandexMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-yandex-map',
                    template: "\n<div class=\"gp-map\">\n    <div class=\"gp-map__wrapper\">\n        <div #container [style.width]=\"widthSafeStyle\" [style.height]=\"heightSafeStyle\" class=\"gp-map__canvas\"></div>\n    </div>\n    <div style=\"display: block; visibility: hidden; position: absolute;\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return YandexMapComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    YandexMapComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: DomSanitizer, },
        { type: NgZone, },
        { type: ExternalResourceService, },
        { type: ConfigService, },
    ]; };
    YandexMapComponent.propDecorators = {
        'width': [{ type: Input },],
        'height': [{ type: Input },],
        'center': [{ type: Input },],
        'zoom': [{ type: Input },],
        'value': [{ type: Input },],
        'disabled': [{ type: Input },],
        'placemarkOptions': [{ type: Input },],
        'isScrolled': [{ type: Input },],
        'allowChoosePoint': [{ type: Input },],
        'onLoad': [{ type: Output },],
        'onInit': [{ type: Output },],
        'onChangeBounds': [{ type: Output },],
        'onViewCheck': [{ type: Output },],
        'onRemoveAll': [{ type: Output },],
        'onPanToDone': [{ type: Output },],
        'container': [{ type: ViewChild, args: ['container',] },],
        'onWindowResize': [{ type: HostListener, args: ['window:resize',] },],
    };
    return YandexMapComponent;
}(AbstractComponent));
export { YandexMapComponent };
//# sourceMappingURL=yandex-map.component.js.map